import animadoAlAparecer from "./animado-al-aparecer";
import cookies from "./cookies";
import popup from "./casa-tenue/popup";
import cabecera from "./casa-tenue/cabecera";
import bloques from "./casa-tenue/bloques";
import '../sass/app.scss';
import tienda from "./casa-tenue/tienda";
var ajustaVw = function () {
    document.documentElement.style.setProperty('--vw', "".concat(document.body.offsetWidth, "px"));
};
var configuraActualizacionDeAltura = function () {
    var ultimoScroll = -1, ultimoAltoCabecera = -1;
    var body = document.body, cabeceraPrincipal = document.querySelector('.cabeceraPrincipal'), actualizaCabecera = function () {
        if (ultimoScroll !== scrollY) {
            body.style.setProperty('--scroll', "".concat(scrollY, "px"));
            ultimoScroll = scrollY;
        }
        if (ultimoAltoCabecera !== cabeceraPrincipal.offsetHeight) {
            var rect = cabeceraPrincipal.getBoundingClientRect();
            var altura = rect.height;
            body.style.setProperty('--alto-cabecera', "".concat(altura, "px"));
            ultimoAltoCabecera = altura;
        }
        requestAnimationFrame(actualizaCabecera);
    };
    addEventListener('load', actualizaCabecera);
    addEventListener('resize', actualizaCabecera);
    actualizaCabecera();
};
var dataLayer = window.dataLayer;
configuraActualizacionDeAltura();
addEventListener('resize', ajustaVw);
addEventListener('load', ajustaVw);
ajustaVw();
animadoAlAparecer('.animado');
cabecera();
tienda();
bloques(dataLayer);
cookies(dataLayer, window.textoCookies);
popup(dataLayer);
